<template>
  <div class="bg-white w-limit wrapper-all">
    <div class="wrapper-sekleton">
      <img src="@/assets/icons/outlet-blue.svg" alt="">
      <div>
        <div class="ph-item m-0 p-0">
          <div class="ph-col-12 p-0 m-0">
            <div class="ph-row m-0">
              <div class="ph-col-12 big m-0"></div>
            </div>
          </div>
        </div>
      </div>
      <img src="@/assets/icons/chevron-rotate-down.svg" alt="">
    </div>
    <div
        class="refresh-wrapper f-cont f-16 f-semi text-primary"
        @click="reload()"
    >
      <img src="@/assets/icons/refresh.svg" alt="">
      <span class="align-items-center">Refresh</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SODropDownOutletSekleton",
  methods:{
    reload(){
      window.location.reload();
    },
  },
}
</script>

<style scoped>
.wrapper-all{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 20px;
}
.wrapper-sekleton {
  display: grid;
  grid-column-gap: 4px;
  grid-template-columns: 16px 100px 16px;
  align-items: center;
}
.refresh-wrapper{
  display: flex;
  align-items: flex-start;
}
</style>